export default __webpack_public_path__ + "static/media/data-algo.f0ac4b5c.png";